  import React from "react";
  import { NavLink, useParams } from "react-router-dom";
  import { FaPhone, FaUser, FaEnvelope, FaLink, FaKey, FaChartBar, FaChartPie } from "react-icons/fa";

  const menuItems = [
    { name: "Overview", icon: FaChartPie, path: "overview", sub: "Health & status" },
    { name: "Quality & Limits", icon: FaChartBar, path: "quality-limits", sub: "Messaging metrics" },
    { name: "Call Settings", icon: FaPhone, path: "calls", sub: "Configure calling settings" },
    // { name: "Message Templates", icon: FaEnvelope, path: "templates",   sub: "Manage templates" },
    // { name: "Webhook Config",    icon: FaLink,     path: "webhook",     sub: "Event endpoints" },
    // { name: "API Settings",      icon: FaKey,      path: "api",         sub: "Keys & access" },
  ];

  const PhoneManagementSidebar = () => {
    const { phoneId } = useParams();

    return (
      <div className="w-72 bg-white border-r border-gray-200 min-h-screen relative flex flex-col">

        {/* Header */}
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Phone Management</h2>
          <p className="text-sm text-gray-500 mt-1">Configure and monitor this number</p>
        </div>

        {/* Navigation */}
        <nav className="p-4 flex-1">
          <div className="space-y-1">
            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                key={item.path}
                to={`/dashboard/manage-phone/${phoneId}/${item.path}`} // use dashboard route
                end={item.path === "overview"} 
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${
                    isActive
                      ? "bg-gradient-to-r from-green-50 to-emerald-50 text-green-600 shadow-sm border border-green-100"
                      : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                  }`
                }
              >
                  {({ isActive }) => (
                    <>
                      <Icon
                        size={18}
                        className={isActive ? "text-green-600" : "text-gray-400"}
                      />
                      <div className="flex-1">
                        <p className="font-medium text-sm">{item.name}</p>
                        <p className="text-xs text-gray-500">{item.sub}</p>
                      </div>
                    </>
                  )}
                </NavLink>
              );
            })}
          </div>
        </nav>

        {/* Footer */}
        <div className="p-4 border-t border-gray-200 bg-gray-50">
          <div className="bg-green-50 border border-green-200 rounded-lg p-3">
            <div className="flex items-start gap-2">
              <FaPhone className="text-green-600 mt-0.5 shrink-0" size={13} />
              <div>
                <p className="text-xs font-medium text-green-900">Phone ID</p>
                <p className="text-xs text-green-700 mt-0.5 font-mono break-all">{phoneId}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  };

  export default PhoneManagementSidebar;